import MissionDefault from 'images/mission-default.png';
import Mission1Img from 'images/mission1.jpg';
import Mission3Img from 'images/mission3.jpg';
import Mission4Img from 'images/mission4.jpg';
import Mission5Img from 'images/mission5.jpg';
import Mission6Img from 'images/mission6.jpg';
import Mission7Img from 'images/mission7.jpg';
import Mission8Img from 'images/mission8.jpg';

import {
  CLEAR_STUDENT_INFO,
  CREATE_CLASS_LOADED,
  GET_STUDENT_INFO_FAILED,
  GET_STUDENT_INFO_LOADED,
  GET_STUDENT_INFO_LOADING,
  GET_USER_INFO_FAILED,
  GET_USER_INFO_LOADED,
  GET_USER_INFO_LOADING,
  REMOVE_CLASS_LOADED,
  REMOVE_STUDENT_LOADED,
  UPDATE_STUDENT_LOADED,
  UPDATE_USER_PROFILE_LOADED,
} from '../actions/user';

// hardcoded avatars to corresponding missions,
// change manually when needed
const missionAvatars = {
  1: Mission1Img,
  2: MissionDefault,
  3: Mission3Img,
  4: Mission4Img,
  5: Mission5Img,
  6: Mission6Img,
  7: Mission7Img,
  8: Mission8Img,
};

// init state
const initialState = {
  username: '',
  first_name: '',
  classrooms: [],
  updatedStudent: {},
  isLoading: false,
  hasErrors: false,
};

// mappers
const mapUserInfo = ({ missions = [], ...rest }) => {
  const parsedMissions = missions.map((mission) => ({ ...mission, image: missionAvatars[mission.number] }));

  return {
    ...rest,
    missions: parsedMissions,
  };
};

const reducer = (state = initialState, action) => {
  let clsrmIdx;
  let parsedStudents;
  let parsedClass;
  let classId;
  switch (action.type) {
    case GET_USER_INFO_LOADING:
    case GET_STUDENT_INFO_LOADING:
      return { ...state, isLoading: true, hasErrors: false };
    case GET_USER_INFO_LOADED:
      return { ...state, ...mapUserInfo(action.payload), isLoading: false, hasErrors: false };
    case CREATE_CLASS_LOADED:
      return { ...state, classrooms: [...state.classrooms, action.payload] };
    case REMOVE_CLASS_LOADED:
      clsrmIdx = state.classrooms.findIndex(({ id }) => +id === +action.payload);
      return {
        ...state,
        classrooms: [...state.classrooms.slice(0, clsrmIdx), ...state.classrooms.slice(clsrmIdx + 1)],
      };
    case REMOVE_STUDENT_LOADED:
      const { studentId } = action.payload;
      classId = action.payload.classId;
      clsrmIdx = state.classrooms.findIndex(({ id }) => +id === +classId);
      parsedStudents = state.classrooms[clsrmIdx]?.students.filter(({ id }) => +id !== +studentId);
      parsedClass = { ...state.classrooms[clsrmIdx], students: parsedStudents };
      return {
        ...state,
        classrooms: [...state.classrooms.slice(0, +clsrmIdx), parsedClass, ...state.classrooms.slice(+clsrmIdx + 1)],
      };
    case GET_STUDENT_INFO_LOADED:
      return { ...state, updatedStudent: { ...action.payload } };
    case UPDATE_STUDENT_LOADED:
      const { data } = action.payload;
      classId = action.payload.classId;
      clsrmIdx = state.classrooms.findIndex(({ id }) => +id === +classId);
      parsedStudents = state.classrooms[clsrmIdx]?.students.map((student) =>
        +student.id === +data.id ? { ...data } : { ...student },
      );
      parsedClass = { ...state.classrooms[clsrmIdx], students: parsedStudents };
      return {
        ...state,
        updatedStudent: { ...data },
        classrooms: [...state.classrooms.slice(0, +clsrmIdx), parsedClass, ...state.classrooms.slice(+clsrmIdx + 1)],
      };
    case GET_USER_INFO_FAILED:
    case GET_STUDENT_INFO_FAILED:
      return { ...state, isLoading: false, hasErrors: true };
    case CLEAR_STUDENT_INFO:
      return { ...state, updatedStudent: {} };
    case UPDATE_USER_PROFILE_LOADED:
      return {
        ...state,
        ...action.user
      };
    default:
      return state;
  }
};

export default reducer;
